import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_PATCHNOTES_BEGIN = "FETCH_PATCHNOTES_BEGIN"
export const FETCH_PATCHNOTES_SUCCESS = "FETCH_PATCHNOTES_SUCCESS"
export const FETCH_PATCHNOTES_ERROR = "FETCH_PATCHNOTES_ERROR"

export const fetchPatchnotesBegin = () => ({
	type: FETCH_PATCHNOTES_BEGIN,
})

export const fetchPatchnotesSuccess = (patchnotes) => ({
	type: FETCH_PATCHNOTES_SUCCESS,
	payload: patchnotes,
})

export const fetchPatchnotesError = (error) => ({
	type: FETCH_PATCHNOTES_ERROR,
	payload: error,
})

export function fetchPatchnotes() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return Promise.resolve()
		dispatch(fetchPatchnotesBegin())
		return fetch(`${URL}api/patchnotes`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchPatchnotesSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, fetchPatchnotesError))
	}
}
